import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=8cb508cc&scoped=true&"
import script from "./ContentList.vue?vue&type=script&lang=js&"
export * from "./ContentList.vue?vue&type=script&lang=js&"
import style0 from "./ContentList.vue?vue&type=style&index=0&id=8cb508cc&lang=scss&scoped=true&"
import style1 from "./ContentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb508cc",
  null
  
)

export default component.exports